<template>
  <top-login-banner v-if="showTopLoginBanner" />
  <technical-shutdown v-if="showTechnicalShutdownBanner" />
  <div
    class="anz-flex anz-flex-wrap anz-justify-content-between anz-align-items-center anz-mt-xl"
  >
    <div class="anz-fs-l">{{ $translate('post.labels.discussion') }}:</div>
    <strong class="anz-strong anz-text-nowrap anz-pr-m" v-if="topic">
      {{ totalCount }}
      {{ $translateCount('post.texts.postCountText', totalCount) }}
    </strong>
  </div>
  <hr class="anz-hr anz-hr-light anz-mt-s anz-mb-l" />
  <Suspense>
    <template #default>
      <post-top-newest-list />
    </template>
    <template #fallback>
      <a-loader class-name="my-l" />
    </template>
  </Suspense>
  <a-loader v-if="loadingList" class-name="anz-mb-l"></a-loader>
  <div class="anz-align-center anz-mb-xxl" v-if="topic">
    <div class="anz-flex anz-flex-column">
      <div>
        <a-button
          class-name="anz-btn anz-btn-primary"
          add-href
          :href="generateTopicRoute(topic)"
        >
          <template #title>
            <template v-if="totalCount > loadedCount">
              {{ $translate('post.actions.detail') }} ({{
                totalCount - loadedCount
              }})
            </template>
            <template v-else>
              {{ $translate('post.actions.detail') }}
            </template>
          </template>
        </a-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ALoader from '@/components/ALoader.vue'
import { usePostListUiActions } from '@/composables/ui/uiActions'
import useTopic from '@/composables/topic/topic'
import TopLoginBanner from '@/components/Post/TopLoginBanner.vue'
import TechnicalShutdown from '@/components/TechnicalShutdown.vue'
import useAppState from '@/composables/ui/ui'
import PostTopNewestList from '@/components/Post/PostTopNewestList.vue'
import usePostsLoader from '@/composables/post/postLoader'
import AButton from '@/components/Forms/AButton.vue'
import { useRouter } from '@/routing/router'

export default defineComponent({
  name: 'PostSimpleList',
  components: {
    AButton,
    PostTopNewestList,
    TechnicalShutdown,
    TopLoginBanner,
    ALoader,
  },
  setup() {
    return {
      ...useTopic(),
      ...usePostListUiActions(),
      ...useAppState(),
      ...usePostsLoader(),
      ...useRouter(),
    }
  },
})
</script>
